import { SIDEBAR_EDIT_CONTENT_KEY } from "fleet/constant/sidebar";
import { MediaListController } from "fleet/controller/media-library/media-list-controller";
import { moveToContentFolderAction } from "fleet/redux-store/content-folders/actions";
import { mediaLibraryArchiveAction } from "fleet/redux-store/media-library";
import {
  redirectToFolderAction,
  closeModalAction,
  openModalAction,
  resetPageStateAction,
  selectMediaAction,
} from "fleet/redux-store/ui-state/media-library";
import { connect } from "react-redux";
import { addErrorMessageAction } from "redux-store/messages";
import { setActiveKeySidebarAction } from "redux-store/ui-state/sidebar";

function mapStateToProps(state) {
  const { app, pages } = state;

  const { isUploading, redirectTo, selected, visibleModal } =
    pages.mediaLibrary;

  return {
    isUploading,
    redirectTo,
    selected,
    visibleModal,
    folders: app.contentFolders,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    archive: (items) => {
      dispatch(mediaLibraryArchiveAction({ items }, "Media Archived!"));
    },
    closeModal: () => {
      dispatch(closeModalAction);
    },
    resetPageState: () => {
      dispatch(resetPageStateAction());
    },
    moveToFolder: (id, items) => {
      dispatch(
        moveToContentFolderAction({ id, items }, "Moved media to folder"),
      );
    },
    onError: (message) => {
      dispatch(addErrorMessageAction(message));
    },
    openModal: (modal) => {
      dispatch(openModalAction(modal));
    },
    redirect: (folderId) => {
      dispatch(redirectToFolderAction(folderId));
    },
    showSidebar: (item) => {
      dispatch(
        setActiveKeySidebarAction(
          SIDEBAR_EDIT_CONTENT_KEY,
          "File Details",
          item,
        ),
      );
    },
    selectMedia: (selected) => {
      dispatch(selectMediaAction(selected));
    },
  };
}

const ConnectedMediaList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MediaListController);

export { ConnectedMediaList };
